import type { TPropostaSimulacao } from '@/features/proposta/services/get-proposta-duplicar.service'
import { extractDateOnly } from '@/utils/date.utils'
import {
  transformEntradasFromApi,
  transformIntermediariasFromApi,
  transformMensaisFromApi,
  transformPosConclusaoFromApi,
} from '@/utils/grupo-parcelas-transformers'

export function transformSimulacaoFromApi(simulacao: TPropostaSimulacao) {
  const intermediariasPosConclusao = simulacao.intermediariasPosConclusao
    ? { intermediariasPosConclusao: transformIntermediariasFromApi(simulacao.intermediariasPosConclusao) }
    : {}

  const saldo = simulacao.saldo
    ? { saldo: { data: extractDateOnly(simulacao.saldo?.data ?? null), valor: simulacao.saldo?.valor ?? 0 } }
    : {}

  const tipoDeAmortizacao = simulacao.configuracoesPreco?.condicoesDePreco?.tipoDeAmortizacao ?? null
  const formaDePagamento = simulacao.formaDePagamento

  const baseData = {
    simulacaoAnteriorId: simulacao.id,
    vendedorId: simulacao.vendedorId,
    clienteId: simulacao.clienteId,
    idExternoBloco: simulacao.bloco.idExterno,
    condicaoDePrecoId: simulacao.configuracoesPreco.condicoesDePreco.id,
    tabelaDePrecoId: simulacao.configuracoesPreco.tabelaDePreco.id,
    rotinaArquivo: simulacao.rotinaArquivo,
    tipoDoProduto: simulacao.produto.tipoDoProduto,
    idExternoProduto: simulacao.produto.idExterno,
    entradas: transformEntradasFromApi(simulacao.entrada ?? []),
    mensais: transformMensaisFromApi(simulacao.mensais ?? []),
    intermediarias: transformIntermediariasFromApi(simulacao.intermediarias ?? []),
    posConclusao: transformPosConclusaoFromApi(simulacao.posConclusao),
    produto: simulacao.produto,
  }

  return {
    ...baseData,
    ...intermediariasPosConclusao,
    ...saldo,
    tipoDeAmortizacao,
    formaDePagamento,
  }
}
